import React from "react";
import { Box, Text, HStack, VStack, Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const SaltPumpDeviceFullRT = ({ pumps }) => {
    const { t } = useTranslation();

    const machineStatus_Direct = [
        { id: 1, label: "Direct Feed", bitPosition: 0, positiveIsGood: true },
    ];


    const machineStatusLabels_9Relay = [
        { id: 1, label: "控制電源", bitPosition: 17, positiveIsGood: true },
        { id: 2, label: "一號泵運行", bitPosition: 10, positiveIsGood: true },
        { id: 3, label: "一號泵故障", bitPosition: 9, positiveIsGood: false },
        { id: 4, label: "二號泵運行", bitPosition: 12, positiveIsGood: true },
        { id: 5, label: "二號泵故障", bitPosition: 11, positiveIsGood: false },
        { id: 6, label: "天台水缸低水位", bitPosition: 16, positiveIsGood: false },
        { id: 7, label: "天台水缸高水位", bitPosition: 15, positiveIsGood: false },
        { id: 8, label: "地下水缸低水位", bitPosition: 14, positiveIsGood: false },
        { id: 9, label: "地下水缸高水位", bitPosition: 13, positiveIsGood: false }, // Estatimate 28Aug2025
    ];

    const machineStatusLabels_6Relay = [
        { id: 1, label: "控制電源", bitPosition: 14, positiveIsGood: true },
        { id: 2, label: "一號泵運行", bitPosition: 10, positiveIsGood: true },
        { id: 3, label: "一號泵故障", bitPosition: 9, positiveIsGood: false },
        { id: 4, label: "二號泵運行", bitPosition: 12, positiveIsGood: true },
        { id: 5, label: "二號泵故障", bitPosition: 11, positiveIsGood: false },
        { id: 6, label: "天台水缸低水位", bitPosition: 13, positiveIsGood: false },   // Estatimate 28Aug2025
        { id: 7, label: "天台水缸高水位", bitPosition: null, positiveIsGood: null },
        { id: 8, label: "地下水缸低水位", bitPosition: null, positiveIsGood: null },
        { id: 9, label: "地下水缸高水位", bitPosition: null, positiveIsGood: null },
    ];

    const machineStatusLabels_RF6Relay = [
        { id: 1, label: "控制電源", bitPosition: 12, positiveIsGood: true },
        { id: 2, label: "一號泵運行", bitPosition: 8, positiveIsGood: true },
        { id: 3, label: "一號泵故障", bitPosition: 7, positiveIsGood: false },
        { id: 4, label: "二號泵運行", bitPosition: 10, positiveIsGood: true },
        { id: 5, label: "二號泵故障", bitPosition: 9, positiveIsGood: false },
        { id: 6, label: "天台水缸低水位", bitPosition: 11, positiveIsGood: false },   // Estatimate 28Aug2025
    ];

    const machineStatusLabels_5Relay = [
        { id: 1, label: "控制電源", bitPosition: null, positiveIsGood: null },
        { id: 2, label: "一號泵運行", bitPosition: 12, positiveIsGood: true },
        { id: 3, label: "一號泵故障", bitPosition: 13, positiveIsGood: false },
        { id: 4, label: "二號泵運行", bitPosition: 10, positiveIsGood: true },
        { id: 5, label: "二號泵故障", bitPosition: 11, positiveIsGood: false },
        { id: 6, label: "天台水缸低水位", bitPosition: 9, positiveIsGood: false },    // Estatimate 28Aug2025
        { id: 7, label: "天台水缸高水位", bitPosition: null, positiveIsGood: null },
        { id: 8, label: "地下水缸低水位", bitPosition: null, positiveIsGood: null },
        { id: 9, label: "地下水缸高水位", bitPosition: null, positiveIsGood: null },
    ];

    const machineStatusLabels_RF5Relay = [
        { id: 1, label: "控制電源", bitPosition: null, positiveIsGood: null },
        { id: 2, label: "一號泵運行", bitPosition: 10, positiveIsGood: true },
        { id: 3, label: "一號泵故障", bitPosition: 11, positiveIsGood: false },
        { id: 4, label: "二號泵運行", bitPosition: 8, positiveIsGood: true },
        { id: 5, label: "二號泵故障", bitPosition: 9, positiveIsGood: false },
        { id: 6, label: "天台水缸低水位", bitPosition: 7, positiveIsGood: false },        // Estatimate 28Aug2025
    ];

    const getStatusLabels = (battery) => {
        const unitDigit = Math.abs(battery) % 10; // Get the unit digit (works for negative numbers too)

        if (unitDigit === 9) return machineStatus_Direct;
        if (unitDigit === 5) return machineStatusLabels_RF6Relay;
        if (unitDigit === 4) return machineStatusLabels_RF5Relay;
        if (unitDigit === 3) return machineStatusLabels_9Relay;
        if (unitDigit === 2) return machineStatusLabels_6Relay;
        if (unitDigit === 1) return machineStatusLabels_5Relay;
        if (unitDigit === 7) return null; // Under Construction case
        return machineStatusLabels_9Relay; // default
    };

    const currentStatusLabels = pumps?.length > 0 ? getStatusLabels(pumps[0].battery) : [];
    const isUnderConstruction = pumps?.length > 0 && Math.floor(pumps[0].battery % 10) === 7;

    return (
        <Box borderWidth="1px" borderRadius="lg" p={4} boxShadow="md" width="100%">
            <Text fontSize="2xl" fontWeight="bold" mb={3}>
                {pumps[0]?.modelName || '未知型號'}沖廁水泵控制箱狀態
            </Text>

            <VStack spacing={2} align="stretch">
                {pumps?.length > 0 ? (
                    isUnderConstruction ? (
                        <Text
                            fontSize="48px"
                            fontWeight="bold"
                            color="orange.500"
                            textAlign="center"
                            py={8}
                        >
                            Under Construction
                        </Text>
                    ) : (
                        currentStatusLabels.map((item, index) => {
                            // For virtual items (bitPosition is null), always show as inactive
                            const isVirtualItem = item.bitPosition === null;

                            // For virtual items, bitValue is always 0
                            // For real items, get the bit value from the status string
                            const bitValue = isVirtualItem
                                ? '0'
                                : pumps[0].status?.charAt(item.bitPosition) || '0';

                            // Determine circle color
                            let circleColor;
                            if (isVirtualItem) {
                                // Virtual items are always gray
                                circleColor = 'gray.500';
                            } else if (bitValue === '1') {
                                circleColor = item.positiveIsGood ? 'green.500' : 'red.500';
                            } else {
                                circleColor = 'gray.500';
                            }

                            // Determine status text
                            let statusText;
                            if (isVirtualItem) {
                                statusText = "不適用";
                            } else if (bitValue === '1') {
                                statusText = item.positiveIsGood ? "運行中" : "異常";
                            } else {
                                statusText = item.positiveIsGood ? "停止" : "正常";
                            }

                            return (
                                <HStack key={item.id} spacing={3} alignItems="center">
                                    <Box w="20px" h="20px" borderRadius="full" bg={circleColor} boxShadow={`0 0 5px ${circleColor}`} flexShrink={0} />
                                    <Text flex={1} fontSize="md">{item.label}</Text>
                                    <Badge
                                        colorScheme={circleColor.replace('.500', '')}
                                        fontSize="sm"
                                        px={2}
                                        py={1}
                                    >
                                        {statusText}
                                    </Badge>
                                </HStack>
                            );
                        })
                    )
                ) : (
                    <Text fontSize="sm">{t("no_pump_data")}</Text>
                )}
            </VStack>
        </Box>
    );
};
